//GLOBAL - components from npm
import React from 'react';
import Routes from './routes/routes';

export default function App() {
  return (
    <Routes />
  );
}
